import React from 'react'
import { RepairAndInquiriesStatusEntity } from '../../../../customEntites/RepairAndInquiries.entity'
import { useTranslation } from 'react-i18next'

export const FilterByStatus = ({
  activeStatus,
  setActiveStatus,
  statuses
}: {
  activeStatus: number,
  setActiveStatus: any,
  statuses: RepairAndInquiriesStatusEntity[]
}) => {
  const { t } = useTranslation()
  return (
    <div className='filter-by-status-wrapper'>
      <div className='status-tabs-holder'>
        <button
          type='button'
          aria-label={localStorage.getItem('SELECTED_LNG') === 'EN' ? 'All cases' : 'Alle Fälle'}
          onClick={() => setActiveStatus(0)}
          key={0}
          className={`status-tab-holder ${activeStatus === 0 ? 'active' : ''}`}
        >
          {localStorage.getItem('SELECTED_LNG') === 'EN' ? 'All' : 'Alle'}
        </button>
        {statuses?.map((status) => {
          return (
            <button
              type='button'
              aria-label={String(t('REPAIR_AND_INQUIRIES.FILTER_BY_STATUS', { status: localStorage.getItem('SELECTED_LNG') === 'EN' ? status?.name : status?.nameDe }))}
              onClick={() => setActiveStatus(status?.id)}
              key={status?.id}
              className={`status-tab-holder ${activeStatus === status?.id ? 'active' : ''}`}
            >
              {localStorage.getItem('SELECTED_LNG') === 'EN' ? status?.name : status?.nameDe}
            </button>
          )
        })}
      </div>
    </div>
  )
}
